import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Empty, Spin, Tag, Typography } from 'antd';
import { PlusOutlined, SettingOutlined, TeamOutlined } from '@ant-design/icons';
import { useWorkspaces } from '@presentation/hooks/useWorkspaces';
import { paths } from '@app/routes/paths';

export const WorkspacesPage = () => {
  const navigate = useNavigate();
  const { data: workspaces, isLoading } = useWorkspaces();

  return (
    <div className="mx-auto max-w-4xl px-6 py-10">
      <div className="mb-6 flex items-center justify-between">
        <Typography.Title level={3} className="!mb-0">
          Workspaces
        </Typography.Title>
        <Link to={paths.newWorkspace}>
          <Button type="primary" icon={<PlusOutlined />}>
            New workspace
          </Button>
        </Link>
      </div>

      {isLoading && <Spin />}

      {!isLoading && workspaces?.length === 0 && (
        <Empty description="You don't belong to any workspace yet.">
          <Link to={paths.newWorkspace}>
            <Button type="primary">Create your first workspace</Button>
          </Link>
        </Empty>
      )}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {workspaces?.map((workspace) => (
          <Card
            key={workspace.id}
            hoverable
            size="small"
            onClick={() => navigate(paths.workbench(workspace.id))}
          >
            <div className="flex items-start justify-between gap-2">
              <div>
                <Typography.Text strong>{workspace.name}</Typography.Text>
                {workspace.description && (
                  <Typography.Paragraph
                    type="secondary"
                    ellipsis={{ rows: 2 }}
                    className="!mb-0 !mt-1"
                  >
                    {workspace.description}
                  </Typography.Paragraph>
                )}
              </div>
              <div className="flex items-center gap-2">
                {workspace.isArchived && <Tag>Archived</Tag>}
                <Link
                  to={paths.workspaceSettings(workspace.id)}
                  onClick={(event) => event.stopPropagation()}
                  aria-label="Workspace settings"
                >
                  <SettingOutlined />
                </Link>
              </div>
            </div>
            <div className="mt-3 flex items-center gap-2 text-xs">
              <Tag className="capitalize">{workspace.type}</Tag>
              <Typography.Text type="secondary">
                <TeamOutlined /> {workspace.memberCount ?? 1} member
                {workspace.memberCount === 1 ? '' : 's'}
              </Typography.Text>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
